import { useTranslation } from "react-i18next";
import { Form, Input, Modal, Alert } from "antd";
import type { FormInstance } from "antd/es/form";
import type { I18nText } from "@/api/products";
import WarningIcon from "@/assets/waring_alert.svg?react";
import {
  I18N_DEFAULT,
  I18N_LANGS,
  I18N_LANG_LABEL,
  clip,
  copyI18n,
  defaultI18n,
} from "../rules";
import styles from "../index.module.scss";
export function I18nModal({
  open,
  max,
  form,
  emptyMessage,
  onCancel,
  onApply,
}: {
  open: boolean;
  max: number;
  form: FormInstance<I18nText>;
  emptyMessage?: string;
  onCancel: () => void;
  onApply: (next: I18nText) => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal
      title={t("products.i18nTitle")}
      open={open}
      onCancel={onCancel}
      onOk={() => {
        const draft = copyI18n(form.getFieldsValue(true));
        if (emptyMessage && !defaultI18n(draft).trim()) {
          form.setFields([{ name: I18N_DEFAULT, errors: [emptyMessage] }]);
          return;
        }
        form.setFields([{ name: I18N_DEFAULT, errors: [] }]);
        onApply(draft);
      }}
      okText={t("common.confirm")}
      cancelText={t("common.cancel")}
      className={styles.modal}
    >
      <Alert
        showIcon
        className={styles.alert}
        title={t("products.i18nHint")}
        type="info"
        icon={<WarningIcon />}
      />
      <Form form={form} layout="vertical" className={styles.formI18n}>
        {I18N_LANGS.map((code) => (
          <Form.Item
            key={code}
            name={code}
            label={t(I18N_LANG_LABEL[code])}
            required={code == I18N_DEFAULT}
          >
            <Input
              maxLength={max}
              showCount
              onChange={(e) => {
                const next = clip(e.target.value, max);
                if (next !== e.target.value) form.setFieldValue(code, next);
              }}
            />
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
}
